import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 3),
    position: "relative",
    margin: "25px 0 0",
    "@media(max-width:1050px)": {
      marginTop: 105,
    },
    [theme.breakpoints.down("sm")]: {
      margin: "105px 16px 0",
      padding: theme.spacing(1, 2),
    },
    [theme.breakpoints.down("xs")]: {
      margin: "120px 16px 0",
    },
    "& .MuiTabs-root": {
      "& button": {
        [theme.breakpoints.down("sm")]: {
          marginRight: 5,
          "& span": {
            // marginLeft: 5,
          },
        },
      },
      "& .MuiTabs-flexContainer": {
        [theme.breakpoints.down("xs")]: {
          width: 200,
          overflowX: "auto",
        },
      },
    },
  },
  rootCoachee: {
    padding: theme.spacing(1, 3),
    position: "relative",
    margin: "25px 0 0",
    overflow: 'unset',
    [theme.breakpoints.down("sm")]: {
      margin: "80px 16px 0",
      padding: theme.spacing(1, 2),
    },
    "& .MuiTabs-root": {
      "& button": {
        [theme.breakpoints.down("sm")]: {
          marginRight: 5,
          "& span": {
            marginLeft: 5,
          },
        },
      },
      "& .MuiTabs-flexContainer": {
        [theme.breakpoints.down("xs")]: {
          overflowX: "auto",
        },
      },
    },
  },
  globalAction: {
    position: "absolute",
    right: 25,
    top: 16,
    [theme.breakpoints.down("sm")]: {
      right: 16,
    },
    "& button": {
      marginRight: 0,
      padding: "5px 10px",
    },
  },
  gridAction: {
    display: "flex",
    alignItems: "center",
  },
  btnlink: {
    padding: "0",
    minWidth: "40px",
    marginRight: 5,
    border: "solid 1px #C2BDBD",
    borderRadius: 20,
    height: 24,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
    boxSizing: "border-box",
    "&:hover": {
      background: "#fff",
    },
    "& svg": {
      fontSize: 16,
    },
    "&:last-child": {
      marginRight: 0,
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: 10,
    },
  },
  userGrid: {
    "& .k-grid": {
      height: '72vh',
      "& .k-grid-header": {
        // border: "none",
        // background: "#ebe8e8",
        "& th": {
          "&:last-child": {
            "& .k-i-more-vertical::before": {
              content: '"\\e11e"',
              color: "#000",
            },
            "& .k-i-more-vertical": {
              background: "#E4E4EA",
              height: 45,
              marginTop: -16,
              width: 24,
              marginRight: -5,
              "&:hover": {
                background: "#9b9b9b",
                transition: ".3s",
              },
            },
          },
        },
      },
    },
    "& th": {
      padding: 12,
    },
    "& .k-grid-header .k-header > .k-link": {
      margin: "-11px -12px !important",
    },
    "& .k-grid-header .k-icon": {
      marginTop: -6,
    },
    "& .k-header .k-link:hover::after": {
      top: 9,
    },
    "& th:last-child": {
      "& .k-link": {
        "&:hover": {
          "&:after": {
            content: "none",
          },
        },
      },
    },
    "& .k-grid-header": {
      paddingRight: "unset",
    },
  },
  noDataImg: {
    minHeight: 300,
  },
  statusBg: {
    width: 125,
    height: 22,
    color: "#fff",
    borderRadius: 25,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11
  },
}));
